import React, { useEffect } from "react"
import { BusinessSelector } from "./businessSelector"
import { Business } from "@/schemas/business"; // Changed to Zod-inferred type
import { useFirebase } from "@/context/FirebaseProvider"; // Added
// import { useSchema } from "@/context/schema/hooks" // Removed
// import { getAuth } from "firebase/auth" // Removed

interface NavBarBusinessSelectorProps {
  businessName?: string
  allBusinesses: Business[]
  onBusinessSelect?: (id: string) => void
  navigate?: ((id: string) => void) | ((to: string) => void)
  hideAllBusinessesOption?: boolean
  isMobile?: boolean
}

export const NavBarBusinessSelector: React.FC<NavBarBusinessSelectorProps> = (
  props
) => {
  const { firebaseUser } = useFirebase(); // Use firebaseUser from FirebaseProvider
  const authUserId = firebaseUser?.uid;

  // Filter businesses to only include those where the current user is a member
  // This logic might be redundant if `props.allBusinesses` (from FirebaseProvider)
  // already only contains businesses the user has access to.
  // For now, keeping the filter as it might provide an additional layer of membership check.
  const filteredBusinesses = authUserId
    ? props.allBusinesses.filter((business) => {
        return business.members?.some(
          (member) => member.userId === authUserId
        );
      })
    : props.allBusinesses;

  return <BusinessSelector {...props} allBusinesses={filteredBusinesses} />
}
